import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { BarSeries, ChartQueryParams, HeatmapChartData, TotalBarData } from '@frontend/chart/types';

export class StockChartClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    public static async fetchTotalFillRate(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<TotalBarData> {
        const response = await this.fetchWithQueryParams(`${this.endpoint}/accounts/${accountId}/fill-rate-total`, undefined, true, undefined, queryParams);
        return await this.handleResponse<TotalBarData>(response);
    }

    public static async fetchFillRateByProduct(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<BarSeries> {
        const response = await this.fetchWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/fill-rate-by-product`,
            undefined,
            true,
            undefined,
            queryParams
        );
        return await this.handleResponse<BarSeries>(response);
    }

    public static async fetchFillRateBySpot(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<BarSeries> {
        const response = await this.fetchWithQueryParams(`${this.endpoint}/accounts/${accountId}/fill-rate-by-spot`, undefined, true, undefined, queryParams);
        return await this.handleResponse<BarSeries>(response);
    }

    public static async fetchOccupiedSlots(
        accountId: string,
        spotId: string,
        moduleId: string,
        queryParams?: ApiQueryParams<ChartQueryParams>
    ): Promise<HeatmapChartData> {
        const response = await this.fetchWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/occupied-slots`,
            undefined,
            true,
            undefined,
            queryParams
        );
        return await this.handleResponse<HeatmapChartData>(response);
    }
}
